const mapTableOfContents = (block) => {
  return {
    __typename: 'WpAcfTableOfContentsBlock',
    TableOfContents: {
      tableOfContents: block?.tableOfContents?.tableOfContents,
    },
  };
};

const mapParagraph = (block) => {
  return {
    __typename: 'WpCoreParagraphBlock',
    saveContent: block?.renderedHtml?.trim(),
  };
};

// eslint-disable-next-line no-unused-vars
const mapSeparator = (block) => {
  return {
    __typename: 'WpCoreSeparatorBlock',
  };
};

const mapHeading = (block) => {
  return {
    __typename: 'WpCoreHeadingBlock',
    saveContent: block?.renderedHtml?.trim(),
    attributes: {
      anchor: block?.anchor || '',
      textAlign: block?.attributes?.textAlign || '',
    },
  };
};

const mapCustomImage = (block) => {
  return {
    __typename: 'WpAcfCustomImageBlock',
    CustomImage: block?.customImage,
  };
};

const mapCallOutBulletList = (block) => {
  return {
    __typename: 'WpAcfCallOutBulletListBlock',
    CallOutBulletList: block?.callOutBulletList,
    ImageIconBulletList: block?.imageIconBulletList,
  };
};

const mapCoreList = (block) => {
  return {
    __typename: 'WpCoreListBlock',
    saveContent: block?.renderedHtml?.trim(),
  };
};

const mapCoreVideo = (block) => {
  return {
    __typename: 'WpCoreVideoBlock',
    attributes: block?.attributes,
  };
};

const mapProductReview = (block) => {
  return {
    __typename: 'WpAcfProductReviewBlock',
    productReview: block?.productReview,
  };
};

const mapNumberedHeading = (block) => {
  return {
    __typename: 'WpAcfNumberedHeadingBlock',
    numberedHeading: block.numberedHeading,
  };
};

const mapCallOutHorizontal = (block) => {
  return {
    __typename: 'WpAcfCallOutHorizontalBlock',
    CallOutHorizontal: block?.callOutHorizontal,
  };
};

const mapSimpleIconList = (block) => {
  return {
    __typename: 'WpAcfSimpleIconListBlock',
    SimpleIconList: block?.simpleIconList,
  };
};

const mapNumberIconList = (block) => {
  return {
    __typename: 'WpAcfNumberIconListBlock',
    SimpleNumberedIconList: block?.simpleNumberedIconList,
  };
};

const mapAccordion = (block) => {
  return {
    __typename: 'WpAcfAccordionBlock',
    Accordion: block?.accordion,
  };
};

const mapCallOutConversation = (block) => {
  return {
    __typename: 'WpAcfCallOutConversationBlock',
    CallOutConversation: block?.callOutConversation,
  };
};

const mapCustomButton = (block) => {
  return {
    __typename: 'WpAcfCustomButtonBlock',
    customButton: block?.customButton,
  };
};

const mapNumberedHeadingWithImage = (block) => {
  return {
    __typename: 'WpAcfNumberedHeadingWithImageBlock',
    numberedHeading: block?.numberedHeading,
    CustomImage: block?.customImage,
  };
};

const mapImageQuote = (block) => {
  return {
    __typename: 'WpAcfImageQuoteBlock',
    ImageQuote: block?.imageQuote,
  };
};

const mapPeopleList = (block) => {
  return {
    __typename: 'WpAcfPeopleListBlock',
    PeopleList: block?.peopleList,
  };
};

const mapHtml = (block) => {
  return {
    __typename: 'WpCoreHtmlBlock',
    saveContent: block?.renderedHtml?.trim(),
  };
};

const mapCustomVideo = (block) => {
  return {
    __typename: 'WpAcfCustomVideoBlock',
    customVideo: block?.customVideo,
  };
};

const mapCoreTable = (block) => {
  return {
    __typename: 'WpCoreTableBlock',
    saveContent: block?.renderedHtml?.trim(),
  };
};

const mapCustomCodeSnippet = (block) => {
  return {
    __typename: 'WpAcfCustomCodeSnippet',
    customCodeSnippet: block?.customCodeSnippet,
  };
};

const mappers = {
  'acf/table-of-contents': mapTableOfContents,
  'core/paragraph': mapParagraph,
  'core/separator': mapSeparator,
  'core/heading': mapHeading,
  'acf/custom-image': mapCustomImage,
  'acf/call-out-bullet-list': mapCallOutBulletList,
  'core/list': mapCoreList,
  'core/video': mapCoreVideo,
  'acf/product-review': mapProductReview,
  'acf/numbered-heading': mapNumberedHeading,
  'acf/call-out-horizontal': mapCallOutHorizontal,
  'acf/simple-icon-list': mapSimpleIconList,
  'acf/number-icon-list': mapNumberIconList,
  'acf/accordion': mapAccordion,
  'acf/call-out-conversation': mapCallOutConversation,
  'acf/custom-button': mapCustomButton,
  'acf/numbered-heading-with-image': mapNumberedHeadingWithImage,
  'acf/image-quote': mapImageQuote,
  'acf/people-list': mapPeopleList,
  'core/html': mapHtml,
  'acf/custom-video': mapCustomVideo,
  'core/table': mapCoreTable,
  'acf/custom-code-snippet': mapCustomCodeSnippet,
};

const mapWpBlockToProps = (block, order) => {
  if (
    !block.name ||
    block.name.length === 0 ||
    block.name === 'core/list-item' ||
    !Object.keys(mappers).includes(block.name)
  ) {
    return null;
  }

  return {
    order,
    ...mappers[block.name](block),
  };
};

module.exports = mapWpBlockToProps;
